import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { doGetPromise } from '../config/core.httpclient-utils';
@Injectable()
export class SearchService {

    private baseUrl = '/api/search';
    private baseUrlProjects = this.baseUrl + '/x/projects';

    constructor(private http: HttpClient) {
        this.http = http;
    }

    search(queryParams: any = {}) {
        return doGetPromise(
            this.http,
            this.baseUrl,
            queryParams
        );
    }

    searchProjects(queryParams: any = {}) {
        if (! queryParams.q?.length) {
            queryParams.q = '%';
        }
        return doGetPromise(
            this.http,
            this.baseUrlProjects,
            queryParams
        );
    }
}